import React from 'react'
import ActivitySVG from './icons/activity.svg'
import AddSVG from './icons/add.svg'
import AlarmSVG from './icons/alarm.svg'
import AltSVG from './icons/alt.svg'
import ArrowDownSVG from './icons/arrow-down.svg'
import ArrowLeftSVG from './icons/arrow-left.svg'
import ArrowRightSVG from './icons/arrow-right.svg'
import ArrowUpSVG from './icons/arrow-up.svg'
import AtSVG from './icons/at.svg'
import AttachmentSVG from './icons/attachment.svg'
import BreatherSVG from './icons/breather.svg'
import BroadcastSVG from './icons/broadcast.svg'
import CalendarSVG from './icons/calendar.svg'
import CalendarAddSVG from './icons/calendar-add.svg'
import CalendarMoreSVG from './icons/calendar-more.svg'
import CalendarSomeday from './icons/calendar-someday.svg'
import CatchupSVG from './icons/catchup.svg'
import ChatSVG from './icons/chat.svg'
import CheckmarkSVG from './icons/checkmark.svg'
import CheckmarkDoubleSVG from './icons/checkmark-double.svg'
import CheckmarkTodoSVG from './icons/checkmark-todo.svg'
import ChevronDownSVG from './icons/chevron-down.svg'
import ChevronLeftSVG from './icons/chevron-left.svg'
import ChevronRightSVG from './icons/chevron-right.svg'
import ChevronUpSVG from './icons/chevron-up.svg'
import ClockSVG from './icons/clock.svg'
import CloudiaSVG from './icons/cloudia.svg'
import CogAltSVG from './icons/cog-alt.svg'
import CollapseSVG from './icons/collapse.svg'
import CreditCardSVG from './icons/creditcard.svg'
import DesktopSVG from './icons/desktop.svg'
import DiscardSVG from './icons/discard.svg'
import DownloadSVG from './icons/download.svg'
import EarthSVG from './icons/earth.svg'
import EscapeSVG from './icons/escape.svg'
import ExpandSVG from './icons/expand.svg'
import EyeSVG from './icons/eye.svg'
import EyeClosedSVG from './icons/eye-closed.svg'
import FacebookSVG from './icons/facebook.svg'
import FilterSVG from './icons/filter.svg'
import FocusSVG from './icons/focus.svg'
import FolderSVG from './icons/folder.svg'
import FolderAddSVG from './icons/folder-add.svg'
import FolderArchiveSVG from './icons/folder-archive.svg'
import FolderDownloadSVG from './icons/folder-download.svg'
import FolderDraftsSVG from './icons/folder-drafts.svg'
import FolderListSVG from './icons/folder-list.svg'
import FolderOpenSVG from './icons/folder-open.svg'
import FolderPutSVG from './icons/folder-put.svg'
import FolderSpamSVG from './icons/folder-spam.svg'
import FolderTodoSVG from './icons/folder-todo.svg'
import FolderTrashSVG from './icons/folder-trash.svg'
import ForceBatchSVG from './icons/force-batch.svg'
import FormattingSVG from './icons/formatting.svg'
import ForwardSVG from './icons/forward.svg'
import FullscreenSVG from './icons/fullscreen.svg'
import GiftSVG from './icons/gift.svg'
import HamburgerSVG from './icons/hamburger.svg'
import HamburgerSidebarSVG from './icons/hamburger-sidebar.svg'
import InboxSVG from './icons/inbox.svg'
import InboxAddSVG from './icons/inbox.svg'
import InboxDoubleSVG from './icons/inbox-double.svg'
import InboxListSVG from './icons/inbox-list.svg'
import InboxNewsletterSVG from './icons/inbox-newsletter.svg'
import InfoSVG from './icons/info.svg'
import InlineDownSVG from './icons/inline-down.svg'
import InlineLeftSVG from './icons/inline-left.svg'
import InlineUpSVG from './icons/inline-up.svg'
import InstagramSVG from './icons/instagram.svg'
import JumpSVG from './icons/jump.svg'
import JumpAltSVG from './icons/jump-alt.svg'
import LabelSVG from './icons/label.svg'
import LabelMiniSVG from './icons/label-mini.svg'
import LinkSVG from './icons/link.svg'
import LinkOutSVG from './icons/link-out.svg'
import ListSVG from './icons/list.svg'
import LoadingSpinSVG from './icons/loading-spin.svg'
import LockSVG from './icons/lock.svg'
import LockWindowSVG from './icons/lock-window.svg'
import MailSVG from './icons/mail.svg'
import MailListSVG from './icons/mail-list.svg'
import MailOpenSVG from './icons/mail-open.svg'
import MailPlusSVG from './icons/mail-plus.svg'
import MailSubbedSVG from './icons/mail-subbed.svg'
import MailUnsubSVG from './icons/mail-unsub.svg'
import MarkdownSVG from './icons/markdown.svg'
import MeatballsHSVG from './icons/meatballs-h.svg'
import MeatballsVSVG from './icons/meatballs-v.svg'
import MoonSVG from './icons/moon.svg'
import MuteSVG from './icons/mute.svg'
import NotificationsSVG from './icons/notifications.svg'
import NuclearSVG from './icons/nuclear.svg'
import OffSVG from './icons/off.svg'
import OutboxSVG from './icons/outbox.svg'
import PaperSVG from './icons/paper.svg'
import PauseSVG from './icons/pause.svg'
import PhoneSVG from './icons/phone.svg'
import PinSVG from './icons/pin.svg'
import PlaySVG from './icons/play.svg'
import PlayButtonSVG from './icons/play-button.svg'
import PlayNewSVG from './icons/play_new.svg'
import PoiSVG from './icons/poi.svg'
import PrintAltSVG from './icons/print-alt.svg'
import PrinterSVG from './icons/printer.svg'
import QueueSVG from './icons/queue.svg'
import RemindSVG from './icons/remind.svg'
import ReplySVG from './icons/reply.svg'
import ReplyAllSVG from './icons/reply-all.svg'
import SearchSVG from './icons/search.svg'
import Search1SVG from './icons/search-1.svg'
import SendSVG from './icons/send.svg'
import SendCancelledSVG from './icons/send-cancelled.svg'
import SendLaterSVG from './icons/send-later.svg'
import SendStopSVG from './icons/send-stop.svg'
import ShareSVG from './icons/share.svg'
import SignSVG from './icons/sign.svg'
import SignatureSVG from './icons/signature.svg'
import SkipSVG from './icons/skip.svg'
import SnoozeMonthSVG from './icons/snooze-month.svg'
import SnoozeTomorrowSVG from './icons/snooze-tomorrow.svg'
import SnoozeWeekSVG from './icons/snooze-week.svg'
import SnoozeWeekendSVG from './icons/snooze-weekend.svg'
import SortSVG from './icons/sort.svg'
import SortAltSVG from './icons/sort-alt.svg'
import SoundSVG from './icons/sound.svg'
import StackSVG from './icons/stack.svg'
import StarSVG from './icons/star.svg'
import StopWatchSVG from './icons/stopwatch.svg'
import SunSVG from './icons/sun.svg'
import TextCenterSVG from './icons/text-center.svg'
import TextJustifySVG from './icons/text-justify.svg'
import TextLeftSVG from './icons/text-left.svg'
import TextRightSVG from './icons/text-right.svg'
import ThumbsDownSVG from './icons/thumbs-down.svg'
import ThumbsUpSVG from './icons/thumbs-up.svg'
import ToDoSVG from './icons/to-do.svg'
import TrendSVG from './icons/trend.svg'
import UserHappySVG from './icons/user-happy.svg'
import UserNeutralSVG from './icons/user-neutral.svg'
import UserSadSVG from './icons/user-neutral.svg'
import VIPSVG from './icons/vip.svg'
import WarningSVG from './icons/warning.svg'
import WarningAltSVG from './icons/warning-alt.svg'

export interface IconProps extends Omit<React.SVGProps<SVGSVGElement>, 'name'> {
  name: keyof IconMap // Use the IconMap type for the 'name' key
  size?: number
}

type IconMap = {
  activity: React.FC<React.SVGProps<SVGSVGElement>>
  add: React.FC<React.SVGProps<SVGSVGElement>>
  alarm: React.FC<React.SVGProps<SVGSVGElement>>
  alt: React.FC<React.SVGProps<SVGSVGElement>>
  'arrow-down': React.FC<React.SVGProps<SVGSVGElement>>
  'arrow-left': React.FC<React.SVGProps<SVGSVGElement>>
  'arrow-right': React.FC<React.SVGProps<SVGSVGElement>>
  'arrow-up': React.FC<React.SVGProps<SVGSVGElement>>
  at: React.FC<React.SVGProps<SVGSVGElement>>
  attachment: React.FC<React.SVGProps<SVGSVGElement>>
  breather: React.FC<React.SVGProps<SVGSVGElement>>
  broadcast: React.FC<React.SVGProps<SVGSVGElement>>
  calendar: React.FC<React.SVGProps<SVGSVGElement>>
  'calendar-add': React.FC<React.SVGProps<SVGSVGElement>>
  'calendar-more': React.FC<React.SVGProps<SVGSVGElement>>
  'calendar-someday': React.FC<React.SVGProps<SVGSVGElement>>
  catchup: React.FC<React.SVGProps<SVGSVGElement>>
  chat: React.FC<React.SVGProps<SVGSVGElement>>
  checkmark: React.FC<React.SVGProps<SVGSVGElement>>
  'checkmark-double': React.FC<React.SVGProps<SVGSVGElement>>
  'checkmark-todo': React.FC<React.SVGProps<SVGSVGElement>>
  'chevron-down': React.FC<React.SVGProps<SVGSVGElement>>
  'chevron-left': React.FC<React.SVGProps<SVGSVGElement>>
  'chevron-right': React.FC<React.SVGProps<SVGSVGElement>>
  'chevron-up': React.FC<React.SVGProps<SVGSVGElement>>
  clock: React.FC<React.SVGProps<SVGSVGElement>>
  cloudia: React.FC<React.SVGProps<SVGSVGElement>>
  'cog-alt': React.FC<React.SVGProps<SVGSVGElement>>
  collapse: React.FC<React.SVGProps<SVGSVGElement>>
  'credit-card': React.FC<React.SVGProps<SVGSVGElement>>
  desktop: React.FC<React.SVGProps<SVGSVGElement>>
  discard: React.FC<React.SVGProps<SVGSVGElement>>
  download: React.FC<React.SVGProps<SVGSVGElement>>
  earth: React.FC<React.SVGProps<SVGSVGElement>>
  escape: React.FC<React.SVGProps<SVGSVGElement>>
  expand: React.FC<React.SVGProps<SVGSVGElement>>
  eye: React.FC<React.SVGProps<SVGSVGElement>>
  'eye-closed': React.FC<React.SVGProps<SVGSVGElement>>
  facebook: React.FC<React.SVGProps<SVGSVGElement>>
  filter: React.FC<React.SVGProps<SVGSVGElement>>
  focus: React.FC<React.SVGProps<SVGSVGElement>>
  folder: React.FC<React.SVGProps<SVGSVGElement>>
  'folder-add': React.FC<React.SVGProps<SVGSVGElement>>
  'folder-archive': React.FC<React.SVGProps<SVGSVGElement>>
  'folder-download': React.FC<React.SVGProps<SVGSVGElement>>
  'folder-drafts': React.FC<React.SVGProps<SVGSVGElement>>
  'folder-list': React.FC<React.SVGProps<SVGSVGElement>>
  'folder-open': React.FC<React.SVGProps<SVGSVGElement>>
  'folder-put': React.FC<React.SVGProps<SVGSVGElement>>
  'folder-spam': React.FC<React.SVGProps<SVGSVGElement>>
  'folder-todo': React.FC<React.SVGProps<SVGSVGElement>>
  'folder-trash': React.FC<React.SVGProps<SVGSVGElement>>
  'force-batch': React.FC<React.SVGProps<SVGSVGElement>>
  formatting: React.FC<React.SVGProps<SVGSVGElement>>
  forward: React.FC<React.SVGProps<SVGSVGElement>>
  fullscreen: React.FC<React.SVGProps<SVGSVGElement>>
  gift: React.FC<React.SVGProps<SVGSVGElement>>
  hamburger: React.FC<React.SVGProps<SVGSVGElement>>
  'hamburger-sidebar': React.FC<React.SVGProps<SVGSVGElement>>
  inbox: React.FC<React.SVGProps<SVGSVGElement>>
  'inbox-add': React.FC<React.SVGProps<SVGSVGElement>>
  'inbox-double': React.FC<React.SVGProps<SVGSVGElement>>
  'inbox-list': React.FC<React.SVGProps<SVGSVGElement>>
  'inbox-newsletter': React.FC<React.SVGProps<SVGSVGElement>>
  info: React.FC<React.SVGProps<SVGSVGElement>>
  'inline-down': React.FC<React.SVGProps<SVGSVGElement>>
  'inline-left': React.FC<React.SVGProps<SVGSVGElement>>
  'inline-up': React.FC<React.SVGProps<SVGSVGElement>>
  instagram: React.FC<React.SVGProps<SVGSVGElement>>
  jump: React.FC<React.SVGProps<SVGSVGElement>>
  'jump-alt': React.FC<React.SVGProps<SVGSVGElement>>
  label: React.FC<React.SVGProps<SVGSVGElement>>
  'label-mini': React.FC<React.SVGProps<SVGSVGElement>>
  link: React.FC<React.SVGProps<SVGSVGElement>>
  'link-out': React.FC<React.SVGProps<SVGSVGElement>>
  list: React.FC<React.SVGProps<SVGSVGElement>>
  'loading-spin': React.FC<React.SVGProps<SVGSVGElement>>
  lock: React.FC<React.SVGProps<SVGSVGElement>>
  'lock-window': React.FC<React.SVGProps<SVGSVGElement>>
  mail: React.FC<React.SVGProps<SVGSVGElement>>
  'mail-list': React.FC<React.SVGProps<SVGSVGElement>>
  'mail-open': React.FC<React.SVGProps<SVGSVGElement>>
  'mail-plus': React.FC<React.SVGProps<SVGSVGElement>>
  'mail-subbed': React.FC<React.SVGProps<SVGSVGElement>>
  'mail-unsub': React.FC<React.SVGProps<SVGSVGElement>>
  markdown: React.FC<React.SVGProps<SVGSVGElement>>
  'meatballs-h': React.FC<React.SVGProps<SVGSVGElement>>
  'meatballs-v': React.FC<React.SVGProps<SVGSVGElement>>
  moon: React.FC<React.SVGProps<SVGSVGElement>>
  mute: React.FC<React.SVGProps<SVGSVGElement>>
  notifications: React.FC<React.SVGProps<SVGSVGElement>>
  nuclear: React.FC<React.SVGProps<SVGSVGElement>>
  off: React.FC<React.SVGProps<SVGSVGElement>>
  outbox: React.FC<React.SVGProps<SVGSVGElement>>
  paper: React.FC<React.SVGProps<SVGSVGElement>>
  pause: React.FC<React.SVGProps<SVGSVGElement>>
  phone: React.FC<React.SVGProps<SVGSVGElement>>
  pin: React.FC<React.SVGProps<SVGSVGElement>>
  play: React.FC<React.SVGProps<SVGSVGElement>>
  'play-button': React.FC<React.SVGProps<SVGSVGElement>>
  'play-new': React.FC<React.SVGProps<SVGSVGElement>>
  poi: React.FC<React.SVGProps<SVGSVGElement>>
  'print-alt': React.FC<React.SVGProps<SVGSVGElement>>
  printer: React.FC<React.SVGProps<SVGSVGElement>>
  queue: React.FC<React.SVGProps<SVGSVGElement>>
  remind: React.FC<React.SVGProps<SVGSVGElement>>
  reply: React.FC<React.SVGProps<SVGSVGElement>>
  'reply-all': React.FC<React.SVGProps<SVGSVGElement>>
  search: React.FC<React.SVGProps<SVGSVGElement>>
  'search-1': React.FC<React.SVGProps<SVGSVGElement>>
  send: React.FC<React.SVGProps<SVGSVGElement>>
  'send-cancelled': React.FC<React.SVGProps<SVGSVGElement>>
  'send-later': React.FC<React.SVGProps<SVGSVGElement>>
  'send-stop': React.FC<React.SVGProps<SVGSVGElement>>
  share: React.FC<React.SVGProps<SVGSVGElement>>
  sign: React.FC<React.SVGProps<SVGSVGElement>>
  signature: React.FC<React.SVGProps<SVGSVGElement>>
  skip: React.FC<React.SVGProps<SVGSVGElement>>
  'snooze-month': React.FC<React.SVGProps<SVGSVGElement>>
  'snooze-tomorrow': React.FC<React.SVGProps<SVGSVGElement>>
  'snooze-week': React.FC<React.SVGProps<SVGSVGElement>>
  'snooze-weekend': React.FC<React.SVGProps<SVGSVGElement>>
  sort: React.FC<React.SVGProps<SVGSVGElement>>
  'sort-alt': React.FC<React.SVGProps<SVGSVGElement>>
  sound: React.FC<React.SVGProps<SVGSVGElement>>
  stack: React.FC<React.SVGProps<SVGSVGElement>>
  star: React.FC<React.SVGProps<SVGSVGElement>>
  stopwatch: React.FC<React.SVGProps<SVGSVGElement>>
  sun: React.FC<React.SVGProps<SVGSVGElement>>
  'text-center': React.FC<React.SVGProps<SVGSVGElement>>
  'text-justify': React.FC<React.SVGProps<SVGSVGElement>>
  'text-left': React.FC<React.SVGProps<SVGSVGElement>>
  'text-right': React.FC<React.SVGProps<SVGSVGElement>>
  'thumbs-down': React.FC<React.SVGProps<SVGSVGElement>>
  'thumbs-up': React.FC<React.SVGProps<SVGSVGElement>>
  'to-do': React.FC<React.SVGProps<SVGSVGElement>>
  trend: React.FC<React.SVGProps<SVGSVGElement>>
  'user-happy': React.FC<React.SVGProps<SVGSVGElement>>
  'user-neutral': React.FC<React.SVGProps<SVGSVGElement>>
  'user-sad': React.FC<React.SVGProps<SVGSVGElement>>
  vip: React.FC<React.SVGProps<SVGSVGElement>>
  warning: React.FC<React.SVGProps<SVGSVGElement>>
  'warning-alt': React.FC<React.SVGProps<SVGSVGElement>>
}

export const ICONS = {
  activity: ActivitySVG,
  add: AddSVG,
  alarm: AlarmSVG,
  alt: AltSVG,
  'arrow-down': ArrowDownSVG,
  'arrow-left': ArrowLeftSVG,
  'arrow-right': ArrowRightSVG,
  'arrow-up': ArrowUpSVG,
  at: AtSVG,
  attachment: AttachmentSVG,
  breather: BreatherSVG,
  broadcast: BroadcastSVG,
  calendar: CalendarSVG,
  'calendar-add': CalendarAddSVG,
  'calendar-more': CalendarMoreSVG,
  'calendar-someday': CalendarSomeday,
  catchup: CatchupSVG,
  chat: ChatSVG,
  checkmark: CheckmarkSVG,
  'checkmark-double': CheckmarkDoubleSVG,
  'checkmark-todo': CheckmarkTodoSVG,
  'chevron-down': ChevronDownSVG,
  'chevron-left': ChevronLeftSVG,
  'chevron-right': ChevronRightSVG,
  'chevron-up': ChevronUpSVG,
  clock: ClockSVG,
  cloudia: CloudiaSVG,
  'cog-alt': CogAltSVG,
  collapse: CollapseSVG,
  'credit-card': CreditCardSVG,
  desktop: DesktopSVG,
  discard: DiscardSVG,
  download: DownloadSVG,
  earth: EarthSVG,
  escape: EscapeSVG,
  expand: ExpandSVG,
  eye: EyeSVG,
  'eye-closed': EyeClosedSVG,
  facebook: FacebookSVG,
  filter: FilterSVG,
  focus: FocusSVG,
  folder: FolderSVG,
  'folder-add': FolderAddSVG,
  'folder-archive': FolderArchiveSVG,
  'folder-download': FolderDownloadSVG,
  'folder-drafts': FolderDraftsSVG,
  'folder-list': FolderListSVG,
  'folder-open': FolderOpenSVG,
  'folder-put': FolderPutSVG,
  'folder-spam': FolderSpamSVG,
  'folder-todo': FolderTodoSVG,
  'folder-trash': FolderTrashSVG,
  'force-batch': ForceBatchSVG,
  formatting: FormattingSVG,
  forward: ForwardSVG,
  fullscreen: FullscreenSVG,
  gift: GiftSVG,
  hamburger: HamburgerSVG,
  'hamburger-sidebar': HamburgerSidebarSVG,
  inbox: InboxSVG,
  'inbox-add': InboxAddSVG,
  'inbox-double': InboxDoubleSVG,
  'inbox-list': InboxListSVG,
  'inbox-newsletter': InboxNewsletterSVG,
  info: InfoSVG,
  'inline-down': InlineDownSVG,
  'inline-left': InlineLeftSVG,
  'inline-up': InlineUpSVG,
  instagram: InstagramSVG,
  jump: JumpSVG,
  'jump-alt': JumpAltSVG,
  label: LabelSVG,
  'label-mini': LabelMiniSVG,
  link: LinkSVG,
  'link-out': LinkOutSVG,
  list: ListSVG,
  'loading-spin': LoadingSpinSVG,
  lock: LockSVG,
  'lock-window': LockWindowSVG,
  mail: MailSVG,
  'mail-list': MailListSVG,
  'mail-open': MailOpenSVG,
  'mail-plus': MailPlusSVG,
  'mail-subbed': MailSubbedSVG,
  'mail-unsub': MailUnsubSVG,
  markdown: MarkdownSVG,
  'meatballs-h': MeatballsHSVG,
  'meatballs-v': MeatballsVSVG,
  moon: MoonSVG,
  mute: MuteSVG,
  notifications: NotificationsSVG,
  nuclear: NuclearSVG,
  off: OffSVG,
  outbox: OutboxSVG,
  paper: PaperSVG,
  pause: PauseSVG,
  phone: PhoneSVG,
  pin: PinSVG,
  play: PlaySVG,
  'play-button': PlayButtonSVG,
  'play-new': PlayNewSVG,
  poi: PoiSVG,
  'print-alt': PrintAltSVG,
  printer: PrinterSVG,
  queue: QueueSVG,
  remind: RemindSVG,
  reply: ReplySVG,
  'reply-all': ReplyAllSVG,
  search: SearchSVG,
  'search-1': Search1SVG,
  send: SendSVG,
  'send-cancelled': SendCancelledSVG,
  'send-later': SendLaterSVG,
  'send-stop': SendStopSVG,
  share: ShareSVG,
  sign: SignSVG,
  signature: SignatureSVG,
  skip: SkipSVG,
  'snooze-month': SnoozeMonthSVG,
  'snooze-tomorrow': SnoozeTomorrowSVG,
  'snooze-week': SnoozeWeekSVG,
  'snooze-weekend': SnoozeWeekendSVG,
  sort: SortSVG,
  'sort-alt': SortAltSVG,
  sound: SoundSVG,
  stack: StackSVG,
  star: StarSVG,
  stopwatch: StopWatchSVG,
  sun: SunSVG,
  'text-center': TextCenterSVG,
  'text-justify': TextJustifySVG,
  'text-left': TextLeftSVG,
  'text-right': TextRightSVG,
  'thumbs-down': ThumbsDownSVG,
  'thumbs-up': ThumbsUpSVG,
  'to-do': ToDoSVG,
  trend: TrendSVG,
  'user-happy': UserHappySVG,
  'user-neutral': UserNeutralSVG,
  'user-sad': UserSadSVG,
  vip: VIPSVG,
  warning: WarningSVG,
  'warning-alt': WarningAltSVG,
} as IconMap

const Icon: React.FC<IconProps> = ({ name, size = 24, ...props }) => {
  const IconComponent = ICONS[name]
  if (!IconComponent) {
    return null // Handle case where the icon doesn't exist
  }
  return (
    <IconComponent aria-label={name} width={size} height={size} {...props} />
  )
}

export default Icon
